import React from 'react'
import LaurelsTitle from './LaurelsTitle'
import { PolicyAddress } from '@/components/policyAddress'
import { useTheme } from '@/components/ThemeProvider'

const AppStoreRating = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const { theme } = useTheme()
  return (
    <section className="pb-10 relative before:absolute before:w-full before:h-full before:-top-1/2 before:left-0 before:translate-y-1/2 before:bg-appStoreRatingBg before:bg-no-repeat before:bg-[left_center] after:absolute after:w-full after:h-full after:bottom-0 after:left-0 after:bg-appStoreRatingAfter after:bg-no-repeat after:bg-[right_bottom]">
      <LaurelsTitle secondary />
      <div className="p-4 mt-14 flex flex-col items-center gap-3 max-w-standard rounded-4xl dark:bg-transparent bg-grayGradientLight dark:bg-grayGradient mx-auto">
        <p className="flex flex-row items-center text-M leading-4 font-bold tracking-[0.5px] gap-1.5">
          <svg width={24} height={24}>
            <use href={`/svg/sprite.svg#apple${theme === 'light' ? '-black' : ''}`}></use>
          </svg>
          <span>App Store</span>
        </p>
        <p className="flex flex-row gap-3 text-LXL2 font-semibold items-center">
          <span>4.6</span>
          <img
            src={`${theme === 'light' ? '/img/rating/light/stars.png' : '/img/rating/stars.png'}`}
            alt="App Store iCleanUP Rating"
            className="max-w-[116px] h-5"
          />
        </p>
        <p className="text-center text-logo font-semibold text-white70">36.9K Ratings</p>
      </div>
      {isWhitePage && <PolicyAddress />}
    </section>
  )
}

export default AppStoreRating
